import { render, staticRenderFns } from "./bodyUploadDocs.vue?vue&type=template&id=5ea92302&scoped=true"
import script from "./bodyUploadDocs.vue?vue&type=script&lang=js"
export * from "./bodyUploadDocs.vue?vue&type=script&lang=js"
import style0 from "./bodyUploadDocs.vue?vue&type=style&index=0&id=5ea92302&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea92302",
  null
  
)

export default component.exports